import { ADD_MODAL_EXPORT } from '../constants/ConfigFileConstant'

export const addModalExport = modal_export => {
    return {
        type: ADD_MODAL_EXPORT,
        payload: {
            modal_export
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/ConfigFileAction.js